import FingerprintJS from '@fingerprintjs/fingerprintjs';

async function useGetFingerprint() {
  const getFp = async () => {
    const fp = await FingerprintJS.load();
    const { visitorId } = await fp.get();
    return visitorId;
  };

  return getFp().then((fingerprint) => fingerprint);
}

export default useGetFingerprint;
